import React from "react";
import { toast } from 'react-toastify';
import svgX from '../../assets/images/icon/x.svg'

const CustomToast = ({ message, closeToast }) => {
    return (
        <div className='default-toast-content'>
            {message}
            <div className="default-toast-close">
                <img src={svgX} />
            </div>
        </div>
    );
};

const showCustomToast = (message, others) => {
    console.log(message, others)
    toast(<CustomToast message={message} closeToast={() => { }} />, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeButton: false,
        pauseOnHover: true,
        draggable: true,
        className: 'default-toast',
        ...others
    });
};

export { showCustomToast };